module.exports = __webpack_public_path__ + "img/Telekom-Logo-840x1000.8758e6c5.svg";